import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'react-bootstrap';
import InitiativeParticipationsTableRow from './InitiativeParticipationsTableRow.jsx';

const InitiativeParticipationsTable = ({
  initiative,
  initiativeParticipations,
  isPreview,
}) => {
  const renderParticipations = (data, depth = 0) => {
    // For supervisors only.
    // Supervisors' children are not real children. only for nice rendering,
    // and has no relation to children of participants
    return data.map((item) => (
      <React.Fragment key={item.id}>
        <InitiativeParticipationsTableRow
          key={item.id}
          isPreview={isPreview}
          initiative={initiative}
          initiativeParticipation={item}
          depth={depth}
        />
        {(!item.participantType || item.participantType === 'Employee') &&
          item.children &&
          renderParticipations(item.children, depth + 1)}
      </React.Fragment>
    ));
  };

  return (
    <Table condensed hover>
      <thead>
        <tr>
          <th>Employee / Group</th>
          {initiative.completionTracked && (
            <React.Fragment>
              <th>Status</th>
              <th>
                <span className="sr-only">Actions</span>
              </th>
            </React.Fragment>
          )}
        </tr>
      </thead>
      <tbody>{renderParticipations(initiativeParticipations)}</tbody>
    </Table>
  );
};

InitiativeParticipationsTable.propTypes = {
  initiative: PropTypes.shape({
    completionTracked: PropTypes.bool,
  }).isRequired,
  initiativeParticipations: PropTypes.array.isRequired,
};

export default InitiativeParticipationsTable;
